import { cloneDeep } from 'lodash';
import {
    GET_STAAD_FILES_STARTING,
    GET_STAAD_FILES_SUCCESS,
    GET_STAAD_FILES_ERROR,
    ADD_STAAD_FILE_SUCCESS,
} from '../../../constants/actionTypes';
import initialState from '../../../store/initialState';

export default function staadFilesReducer(state = initialState.staadFiles, action) {
    switch (action.type) {
        case GET_STAAD_FILES_STARTING: {
            const newState = cloneDeep(state);
            newState.loading = true;
            newState.loaded = false;
            return newState;
        }

        case GET_STAAD_FILES_SUCCESS: {
            const newState = cloneDeep(state);
            const ids = [];
            const map = {};

            // console.log('staadFile', action.data)
            action.data.staadFiles.forEach((staad) => {
                const staadId = staad.id;
                ids.push(staadId);
                map[staadId] = staad;
            });

            newState.ids = ids;
            newState.map = map;

            newState.loading = false;
            newState.loaded = true;

            return newState;
        }

        // case ADD_STAAD_FILE_SUCCESS: {
        //     const newState = cloneDeep(state);
        //     const { staad } = action.data;

        //     const staadId = staad.id;

        //     newState.map[staadId] = staad;
        //     newState.ids.push(staadId);

        //     newState.ids.sort((stdId, std2Id) => {
        //         const std = newState.map[stdId];
        //         const std2 = newState.map[std2Id];
        //         return std.id - std2.id;
        //     });

        //     return newState;
        // }

        case GET_STAAD_FILES_ERROR: {
            const newState = cloneDeep(state);
            newState.loading = false;
            newState.loaded = false;
            newState.error = action.err ? action.err : 'Failed to retrieve staad files.';
            return newState;
        }

        default: {
            return state;
        }
    }
}